import { getNotificationList, getSetNotificationAllRead, setMsgReaded } from "@/api/notification"
import { getCookie } from "@/utils/support"
import { Message } from 'element-ui';
import Notify from "@/components/notificationBar/dialog"
import route from '@/router'

/** 该状态模块和notification组件和消息中心页面强关联 */
/** 默认消息预览对象 */
const defaultMsgPreviewObject = {
  create_time_text: '',
  tip_name: '',
  tip_word: '',
  id: null
}

export default {
  namespaced: true,
  state: {
    /** 消息操作弹窗是否可见 */
    notificationBarVisable: false,
    /** 消息预览 用于右上角消息弹出 */
    notificatioPreview: {
      dialog: [],
      page: [],
      menu: [],
      system_notice_unread_num: 0,
      update_notice_unread_num: 0
    },
    /** 消息弹窗分类id */
    dialogCategoryId: 0,
    /** 消息中心页面分类id */
    pageCategoryId: 0,
    pageQuery: {
      msgPage: 1,
      msgLimit: Number(getCookie('notification_center_limit')) || 10,
      msgTotal: 0,
      type: false /** 0全部信息 1只看未读 */
    },
    /** 列表加载状态 */
    dialogLoading: false,
    listLoading: false,
    /** 消息中心消息预览对象 */
    msgPreviewObject: defaultMsgPreviewObject,
    /** 需要在列表匹配的消息id */
    matchMsgId: null,
    /** 缓存消息池 */
    msgPool: []
  },
  getters: {
    notificationBarVisable: state => state.notificationBarVisable,
    notificatioPreview: state => state.notificatioPreview,
    hasUnReadMsg: state => state.notificatioPreview.system_notice_unread_num || state.notificatioPreview.update_notice_unread_num,
    dialogCategoryId: state => state.dialogCategoryId,
    pageCategoryId: state => state.pageCategoryId,
    dialogLoading: state => state.dialogLoading,
    listLoading: state => state.listLoading,
    msgPreviewObject: state => state.msgPreviewObject,
    pageQuery: state => state.pageQuery
  },
  actions: {
    /**
     * @description 打开或者关闭消息弹窗
     * @param outter {Boolean} 是否点击弹窗外
     */
    toggleNotificationBarVisable({ commit, state }, outter = false) {
      if (state.notificationBarVisable) {
        return commit('SET_DIALOG_VISIABLE', false)
      } else {
        if (outter == false) return commit('SET_DIALOG_VISIABLE', true)
      }
    },
    /**
     * @description 初始化消息分类
     */
    initNotificationCategory({ commit, state, dispatch }, payload = { categoryId: null, matchMsgId: null }) {
      console.log('initNotificationCategory');

      const { categoryId, matchMsgId } = payload

      getNotificationList({ limit: 5, page: 1, category_id: 0 }).then(res => {
        if (res.data.status == 200) {
          const { menu, system_notice_unread_num, update_notice_unread_num } = res.data.data
          const system = menu.find(item => item.name == '系统消息')
          const log = menu.find(item => item.name == '更新日志')
          if (system) {
            system.unread = Number(system_notice_unread_num)
            system.class = 'icon-broadcast'
          }
          if (log) {
            log.unread = Number(update_notice_unread_num)
            log.class = 'icon-update'
          }

          /** 为dialog和page设置默认消息分类id */
          commit('SET_DIALOG_CATEGORY_ID', menu[0].id)
          commit('SET_PAGE_CATEGORY_ID', menu[0].id)
          /** 只更新分类 不加载消息 */
          commit('SET_NOTIFICATION_LIST', { dialog: [], menu, system_notice_unread_num, update_notice_unread_num })
          if (menu.length) {
            /** 在新标签页打开 开始匹配消息 */
            if (categoryId && matchMsgId) {
              dispatch('updateCurrentCategoryId', {
                categoryId: categoryId,
                matchMsgId: matchMsgId,
                center: true
              })
            } else {
              /** 初始化时不打开消息弹窗 但是默认加载*/
              dispatch('fetchMsgListByCategoryId')
              dispatch('fetchMsgListByCategoryId', { center: true })
            }
          }
        }
      })
    },
    /**
     * @description 更新弹窗和消息中心分类id
     * @param {Number} categoryId 分类id
     * @param {Boolean} center 是否消息中心
     */
    updateCurrentCategoryId({ commit, dispatch, state }, payload = { categoryId: null, matchMsgId: null, center: false }) {
      if (payload.center) {
        /** 需要匹配的Msgid 做新窗口默认消息预览用 */
        payload.matchMsgId && commit('SET_MATCH_MSG_ID', payload.matchMsgId)
        /** 新标签页 */
        if (payload.categoryId && payload.matchMsgId) {
          /** 重置消息中心分类 */
          commit('SET_PAGE_CATEGORY_ID', payload.categoryId)
          /** 重置消息中心列表 */
          commit('SET_NOTIFICATION_LIST', { page: [], msgPage: 1 })
          /** 加载数据 */
          dispatch('fetchMsgListByCategoryId', { center: true, sync: true })
        }
        /** 消息中心手动切换 */
        if (payload.categoryId !== state.pageCategoryId) {
          /** 重置消息中心分类 */
          commit('SET_PAGE_CATEGORY_ID', payload.categoryId)
          /** 重置消息中心列表 */
          commit('SET_NOTIFICATION_LIST', { page: [], msgPage: 1 })
          /** 加载数据 */
          dispatch('fetchMsgListByCategoryId', { center: true, sync: false })
        }
      } else {
        if (payload.categoryId !== state.dialogCategoryId) {
          commit('SET_DIALOG_CATEGORY_ID', payload.categoryId)
          commit('SET_NOTIFICATION_LIST', { dialog: [] })
          dispatch('fetchMsgListByCategoryId')
        }
      }
    },
    /**
     * @description 根据分类id获取消息列表 对dialog和消息中心有效
     */
    fetchMsgListByCategoryId({ commit, state, dispatch }, payload = { center: false, sync: false, reset: false }) {
      /** 设置加载状态 */
      commit('SET_MSG_LIST_LOADING', { dialogLoading: !payload.center, listLoading: payload.center })
      /** 处理消息时将消息中心page重置为第一页  */
      payload.reset && dispatch('updatePageQuery', { reset: true })
      /** 组合参数 */
      getNotificationList({
        limit: payload.center ? state.pageQuery.msgLimit : 5,
        page: payload.center ? state.pageQuery.msgPage : 1,
        category_id: payload.center ? state.pageCategoryId : state.dialogCategoryId,
        type: state.pageQuery.type ? 1 : 0
      }).then(res => {
        if (res.data.status == 200) {
          const { data, menu, system_notice_unread_num, update_notice_unread_num, total } = res.data.data
          /** 从列表数据合并未读 */
          const system = menu.find(item => item.name == '系统消息')
          const log = menu.find(item => item.name == '更新日志')
          if (system) {
            system.unread = Number(system_notice_unread_num)
            system.class = 'icon-broadcast'
          }
          if (log) {
            log.unread = Number(update_notice_unread_num)
            log.class = 'icon-update'
          }
          const updateQuery = payload.center ?
            { page: data, menu, system_notice_unread_num, update_notice_unread_num } :
            { dialog: data, menu, system_notice_unread_num, update_notice_unread_num }
          /** 为消息中心设置total */
          if (payload.center) commit('SET_LIST_PAGE_QUERY', { msgTotal: total })
          /** 同步给dialog 给消息匹配页dialog设置消息中心的分类id */
          if (payload.sync) {
            updateQuery.dialog = [...data].splice(0, 5)
            commit('SET_DIALOG_CATEGORY_ID', state.pageCategoryId)
          }
          /** 存在需要匹配的消息id */
          if (state.matchMsgId) {
            let targetMsg = data.find(item => item.id == state.matchMsgId);
            commit('SET_MATCH_MSG_ID', null)
            targetMsg && commit('SET_PREVIEW_MSG_OBJ', targetMsg)
          }
          commit('SET_NOTIFICATION_LIST', updateQuery)
        }
      }).finally(f => {
        commit('SET_MSG_LIST_LOADING', { dialogLoading: false, listLoading: false })
      })
    },
    /** 根据分类id全部为已读 */
    updateAllReadByCategoryId({ dispatch, state }, { center = false }) {
      const { system_notice_unread_num, update_notice_unread_num } = state.notificatioPreview
      if ((system_notice_unread_num + update_notice_unread_num) == 0) return
      getSetNotificationAllRead({
        category_id: center ?
          state.pageCategoryId :
          state.dialogCategoryId
      }).then(res => {
        if (res.data.status == 200) {
          /** 不在消息中心操作  */
          const { name } = route.app._route;
          if (name !== "notificationCenter") {
            dispatch('fetchMsgListByCategoryId', { center, reset: true })
          } else {
            dispatch('fetchMsgListByCategoryId')
            dispatch('fetchMsgListByCategoryId', { center: true, reset: true })
          }
        }
      })
    },
    /**
     * @description 更新消息预览对象
     * @param {Object} msg 消息对象
     * @param {Boolean} macthMsg 在消息中心匹配显示预览
     */
    msgPreviewAction({ commit, state, dispatch }, payload = { msg: {}, macthMsg: false, center: false }) {
      const { category_id, id, read } = payload.msg
      commit('SET_PREVIEW_MSG_OBJ', { ...payload.msg }, { read: 1 })
      /** 在消息中心匹配到该条信息并显示预览 */
      if (payload.macthMsg) {
        /** 与当前消息中心分类不等于 从接口请求该分类的最新消息 */
        if (category_id !== state.pageCategoryId) {
          /** 到消息中心查看 */
          dispatch('updateCurrentCategoryId', { categoryId: category_id, center: true })
        }
      }
      /** 处理未读 */
      if (Boolean(Number(read) == false && payload.center)) {
        dispatch('msgReadedAction', id)
      }
    },
    /** 设置单条消息为已读 */
    msgReadedAction({ dispatch }, msgId = null) {
      setMsgReaded({ tip_id: Number(msgId), type: 1 }).then(res => {
        if (res.data.status !== 200) {
          Message({
            message: res.data.msg,
            type: "error",
            duration: 2000
          });
        }
      }).finally(f => {
        dispatch('fetchMsgListByCategoryId')
        dispatch('fetchMsgListByCategoryId', { center: true })
      })
    },
    /** 更新消息中心page参数 */
    updatePageQuery({ commit, dispatch }, payload = { msgPage, msgLimit, reset: false }) {
      const resetQuery = payload.reset ? { msgPage: 1 } : {}
      commit('SET_LIST_PAGE_QUERY', { ...payload, ...resetQuery })
      dispatch('fetchMsgListByCategoryId', { center: true })
    },
    /** 处理从socket获取的消息数据 */
    notificationHandle({ commit, dispatch, state }, msgText = '') {
      /** 处理消息文本 */
      const originText = msgText.toString().trim()
      if (originText && originText !== '[]' && !['0','1'].includes(originText)) {
        try {
          const MSG = JSON.parse(msgText)

          // if(Array.isArray())
          const { tip_id, category_id, tip_name, pop_type, tip_word, tip_description, create_time, is_eject, type } = MSG
          console.log(`收到信息:` + JSON.stringify(MSG))

          /** 未接收过该消息id 在消息池插入 */
          if (state.msgPool.includes(String(tip_id)) == false) {
            commit('INSERT_MSG_POOL', String(tip_id))
            // console.log(state.msgPool)
            /** 是否弹出通知 */
            if (is_eject) {
              /** 更新dialog和消息中心 */
              dispatch('fetchMsgListByCategoryId')
              dispatch('fetchMsgListByCategoryId', { center: true })
              /** 推送一个弹窗通知 */
              return Notify({
                msgId: String(tip_id),
                title: tip_name,
                tiny: pop_type == 2,
                content: tip_description,
                createTime: create_time,
                type
              }).then(res => {
                /** 更新消息未已读 */
                res.done && dispatch('msgReadedAction', Number(tip_id))
                /** 查看消息详情操作 */
                if (res.more) {
                  const { name } = route.app._route;
                  /** 不在消息中心操作  */
                  if (name !== "notificationCenter") {
                    /** 标记当前弹窗消息为已读 */
                    dispatch('msgReadedAction', Number(tip_id))
                    /** 打开消息中心查看新消息 */
                    let newTab
                    // 4 为采购需求退回通知 直接跳转采购需求列表
                    if(type == 4) {
                      newTab = route.resolve({
                        path: `/procure/procureCP?status=6`
                      });
                    }else {
                      newTab = route.resolve({
                        path: `/notification/center?category_id=${category_id}&msg_id=${tip_id}`
                      });
                    }
                    return window.open(newTab.href, "_blank");
                  } else {
                    dispatch('msgReadedAction', Number(tip_id))
                  }
                }
              })
            } else {
              /** 静默通知 */
              dispatch('fetchMsgListByCategoryId')
              dispatch('fetchMsgListByCategoryId', { center: true })
            }
          }
        }
        catch (error) {
          console.warn(`无效信息:${msgText}`)
        }
      } else if (originText == '[]') {
        /** 清空所有标签页通知div */
        dispatch('clearAllTabReadedNotification')
      } else {
        console.warn(`无效信息:${msgText}`)
      }
    },
    /** 清除所有标签消息池的消息 */
    clearAllTabReadedNotification({ commit, state, dispatch }) {
      let { msgPool = [] } = state
      msgPool.map(msgId => {
        let notificationDiv = document.getElementById(`notification-${msgId}`)
        notificationDiv && document.body.removeChild(notificationDiv)
      })
      if (msgPool.length) {
        commit('CLEAR_MSG_POOL')
        const { name } = route.app._route;
        if (name !== "notificationCenter") {
          dispatch('fetchMsgListByCategoryId')
        } else {
          dispatch('fetchMsgListByCategoryId')
          dispatch('fetchMsgListByCategoryId', { center: true })
        }
      }
    }
  },
  mutations: {
    'SET_NOTIFICATION_LIST'(state, data) {
      state.notificatioPreview = Object.assign({}, state.notificatioPreview, data)
    },
    'SET_DIALOG_VISIABLE'(state, visible) {
      state.notificationBarVisable = visible
    },
    'SET_DIALOG_CATEGORY_ID'(state, categoryId) {
      state.dialogCategoryId = categoryId
    },
    'SET_PAGE_CATEGORY_ID'(state, categoryId) {
      state.pageCategoryId = categoryId
    },
    'SET_MSG_LIST_LOADING'(state, { dialogLoading, listLoading }) {
      state.dialogLoading = dialogLoading
      state.listLoading = listLoading
    },
    'SET_PREVIEW_MSG_OBJ'(state, msgObj) {
      state.msgPreviewObject = Object.assign({}, msgObj)
    },
    'SET_MATCH_MSG_ID'(state, matchMsgId) {
      state.matchMsgId = matchMsgId
    },
    'SET_LIST_PAGE_QUERY'(state, pageQuery = {}) {
      state.notificatioPreview.page = []
      state.pageQuery = { ...state.pageQuery, ...pageQuery }
    },
    'INSERT_MSG_POOL'(state, msgId) {
      state.msgPool = state.msgPool.concat(msgId)
    },
    'CLEAR_MSG_POOL'(state) {
      state.msgPool = []
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/notification.js